export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-4">
            关于迷妹漫画
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            迷妹漫画是一个专注完结漫画大全的在线阅读平台。我们深知漫画迷追更的辛苦——等更新、怕断更、追到一半作者休刊，这些都让人抓狂。所以我们只做一件事：聚合那些已经完结的漫画全集和漫画完整版，让你随时随地打开就能一口气刷到最终话大结局。从经典老漫到近年热门完结作品，从热血战斗到甜蜜恋爱，迷妹漫画网的完结漫画资源库每天都在扩充，支持竖屏连续滚动阅读，无需翻页点击，下拉即可沉浸式追漫。无论你是用电脑还是手机，打开迷妹漫画，完结漫画的快乐触手可及。
          </p>
        </div>
      </div>
    </section>
  );
}